<script setup lang="ts">
import { ref, watch } from 'vue'
import { FwbTab, FwbTabs } from 'flowbite-vue'
import EnrichedTicket from "./EnrichedTicket.vue";

import adminAPI from '../../services/api';
import { UsersTicketsHistorySchema } from '../../interfaces';
import BaseLoader from '@/components/ui/loaders/BaseLoader.vue';
import { TicketMinusIcon } from 'lucide-vue-next';

const activeTab = ref('')

const props = defineProps<{ claimId: string }>();

const usersTickets = ref<UsersTicketsHistorySchema>([]);
const loading = ref(true);

watch(() => props.claimId, async (claimId) => {
  loading.value = true;
  // activeTab.value = ""
  try {
    usersTickets.value = await adminAPI.retrieveClaimETicketsHistory(claimId);
    activeTab.value = usersTickets.value[0].user.id
  } finally {
    loading.value = false;
  }
}, { immediate: true });
</script>
<template>
<div>
  <fwb-tabs v-model="activeTab" variant="underline" class="w-full py-5">
    <fwb-tab v-for="{ user, tickets } of usersTickets" :name="user.id" :title="user.firstName" :key="user.id">
      <div v-for="ticket of tickets" class="-mx-4 gap-y-8">
        <EnrichedTicket :ticket="ticket" />
      </div>
      <!-- <pre class="text-left">{{ tickets }}</pre> -->
    </fwb-tab>
  </fwb-tabs>
  <div v-if="!activeTab && loading">
    <BaseLoader />
  </div>
  <div v-else-if="!activeTab && !loading" class="px-8 py-4 mb-8 border rounded-md">
    <div class="text-center">
      <TicketMinusIcon :size="32" class="mx-auto text-gray-400" />
      <h3 class="mt-2 text-sm font-semibold text-gray-900">Aucun billet détecté</h3>
      <p class="mt-1 text-sm text-gray-500">Cela peut arriver pour des dossiers hors GDS ou avec des PNRs archivés.</p>
    </div>
  </div>
</div>
</template>